import { Grid } from "@mui/material";
import { Box, Typography } from "@mui/material";
import React from "react";
import { useNavigate } from "react-router";
import { ReactComponent as Logo } from "../theme/icons/logo-nou.svg";
import { styled } from "@mui/material";

const WrapFooter = styled(Typography)(({ theme }) => ({
	paddingTop: 100,
	paddingBottom: 100,
	backgroundColor: theme.palette.background.default,
	zIndex: 0,
	width: "100%",
}));

const Footer = () => {
	const navigate = useNavigate();

	return (
		<WrapFooter>
			<Grid container spacing={10}>
				<Grid item size={{ md: 4, xs: 12 }}></Grid>
				<Grid item size={{ md: 4, xs: 12 }}>
					<Box
						my={2}
						style={{ cursor: "pointer", textAlign: "center" }}
					>
						<Logo
							style={{ width: 200, height: 200, fill: "white" }}
						/>
						<Box my={2} />

						<div onClick={() => navigate("/politica-privacitat")}>
							<Typography style={{ color: "white" }}>
								Política de privacitat
							</Typography>
						</div>
						<div onClick={() => navigate("/avis-legal")}>
							<Typography style={{ color: "white" }}>
								Avís legal
							</Typography>
						</div>
					</Box>
				</Grid>
				<Grid item size={{ md: 4, xs: 12 }}></Grid>
			</Grid>
		</WrapFooter>
	);
};

export default Footer;
